<template>
	<div>
        <b-row>
            <b-col>
                <b-form-group :label="$t('semester')">
                    <div class="label-as-input">{{ isNotNullValue(formData.semester) }}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('program_code')">
                    <div class="label-as-input">{{ isNotNullValue(formData.program_code)}}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('exam')">
                    <div class="label-as-input">{{ isNotNullValue(formData.exam)}}</div>
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group :label="$t('rate')">
                    <div class="label-as-input">{{ isNotNullValue(formData.rate)}}</div>
                </b-form-group>
            </b-col>
        </b-row>
	</div>
</template>

<script>
// Components

// Services
import ConservatoryApplicationExamTypeService from "@/services/ConservatoryApplicationExamTypeService";

// Other
export default {
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {},
            formLoading: false,
        }
    },

    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            ConservatoryApplicationExamTypeService.get(id)
                          .then(response => {
                              this.formData = response.data.data;
                          })
                          .catch(e => {
                              this.showErrors(e)
                          })
        },


    }
}
</script>
